import { CONVERSATION_PARTS } from './conversationParts';
import type { ConversationStyleConfig } from './types';

export const CONVERSATION_STYLE_CONFIG: ConversationStyleConfig = {
  parts: CONVERSATION_PARTS,
  baseStyle: {
    container: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'stretch',
    },
    content: {
      mt: 1.5,
      position: 'relative',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'stretch',
      flexGrow: 1,
      minH: 0,
      overflowY: 'auto',
    },
    scrollButton: {
      position: 'absolute',
      bottom: 2,
      left: '50%',
      transform: 'translateX(-50%)',
      boxShadow: 'popover',
      outline: 'none',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      bg: 'interaction.main',
      color: 'feature.onInteraction',
      transition: 'opacity',
      transitionDuration: 'fast',
      _hover: {
        bg: 'interaction.hover',
      },
      _active: {
        bg: 'interaction.active',
      },
      _disabled: {
        opacity: 0,
        pointerEvents: 'none',
        cursor: 'not-allowed',
      },
    },
    scrollButtonPositioner: {
      position: 'relative',
      height: 0,
      zIndex: 2,
    },
    skeleton: {
      flexGrow: 1,
      minH: 0,
      px: 1.25,
      pt: 1.5,
      pb: 2,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'flex-start',
      alignItems: 'stretch',
      gap: 2,
    },
  },
  defaultProps: {},
};
